import React, { useRef, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import CMSFormInput from "../../formFields/CMSFormInput";
import GeneralButton from "../../common/GeneralButton";
import ContainerLoading from "../../common/loading/ContainerLoading";
import { useToast } from "../../contexts/ToastContext";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { changeEmailSchema, passwordSchema } from "../../utils/validations";
import axios from "../../../config/axios";

// Validation schema

const ChangeEmail = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const { addToast } = useToast();
  const navigate = useNavigate();
  const refs = {
    currentPassword: useRef(null),
    newPassword: useRef(null),
    confirmPassword: useRef(null),
  };

  const scrollToFirstError = (errors) => {
    const firstErrorField = Object.keys(errors)[0];
    if (!firstErrorField || !refs[firstErrorField]?.current) return;

    const el = refs[firstErrorField].current;

    // Smoothly scroll the nearest scrollable parent
    el.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });

    // Give the scroll some time to finish, then focus
    setTimeout(() => {
      el.focus?.({ preventScroll: true });
    }, 500); // adjust based on your animation speed
  };
  return (
    <div className="mt-6 flex flex-col gap-6 bg-[#DEE2DD]/40 rounded-[15px] p-10 lg:px-12 w-full relative">
      {/* Header */}
      <div className="flex items-center gap-4 mb-4">
        {/* <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 pe-3 py-2 bg-gray-200 rounded hover:bg-gray-300 transition"
        >
          <FiArrowLeft size={30} />
        </button> */}
        <p className="text-24pt">Change Email</p>
      </div>
      {status === "loading" && (
        <div className="absolute inset-0 flex items-center justify-center rounded-[15px] z-10 bg-white/50">
          <ContainerLoading />
        </div>
      )}
      <div className="flex flex-col gap-6  rounded-[15px]  relative">
        <Formik
          initialValues={{
            password: "",
            newEmail: "",
            confirmEmail: "",
          }}
          validationSchema={changeEmailSchema}
          onSubmit={async (values, { resetForm }) => {
        
            setStatus("loading");

            try {
              // Prepare form data (especially if image upload is supported)

              // ✅ Send API request to update profile
              const res = await axios.post(
                "/dashboard/profile/change-email",
                values
              );

              // ✅ Handle response
              if (res.status === 200 || res.status === 201) {
                addToast("Email updated successfully", "success");
                resetForm({ values });
                setStatus("idle");
                navigate("/account/profile");
              } else {
                throw new Error("Update failed");
              }
            } catch (err) {
              
              setError(
                err?.response?.data?.error ||
                  "Email update failed, please try again."
              );
              setTimeout(() => {
                setError("");
              }, 5000);
              setStatus("idle");
            }
          }}
        >
          {(form) => (
            <div className="w-full grid grid-cols-1 gap-8">
              {/* Current Password */}

              {/* New Password */}
              <CMSFormInput
                name="newEmail"
                label="New Email"
                form={form}
                ref={refs.newPassword}
                className="1"
                required
              />

              {/* Confirm Password */}
              <CMSFormInput
                name="confirmEmail"
                label="Confirm Email"
                form={form}
                ref={refs.confirmPassword}
                className="1"
                required
              />
              <CMSFormInput
                name="password"
                label="Password"
                type="password"
                form={form}
                ref={refs.currentPassword}
                className="1"
                required
              />
              {error && (
                <div
                  className={`relative transition-all duration-300 ease-in-out ${
                    error
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 -translate-y-2"
                  }`}
                >
                  {error && <span className="errorMessage">{error}</span>}
                </div>
              )}
              {/* Submit Button */}
              <div className="flex justify-end">
                <GeneralButton
                  text={"Submit"}
                  type="submit"
                  className="text-lg px-4"
                  textColor="#fff"
                  onClick={() => {
                    form.handleSubmit();
                    setTimeout(() => scrollToFirstError(form?.errors), 100);
                  }}
                  disabled={loading}
                />
              </div>
            </div>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangeEmail;
